import React, { useState, useEffect, useRef } from "react";
import {
  Accordion,
  Button,
  Card,
  Col,
  Collapse,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  Spinner,
  Table,
  Tooltip,
} from "react-bootstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Link, useNavigate } from "react-router-dom";
import "./adminDashboard.scss";
import imageCompression from 'browser-image-compression';

// import avatar1 from "../../../images/avatar/1.jpg";
import avatar1 from "../../images/avatar/1.jpg";
import ServiceRequestDetails from "../serviceRequestDetails/serviceRequestDetails";
import CallDetails from "../callDetails/callDetails";
import AddUserByAdmin from "../addUserByAdmin/addUserByAdmin";
import ParticularUserDetailsForAdmin from "../particularUserDetailsForAdmin/particularUserDetailsForAdmin";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { registeredUser } from "../../service/api/user/registeredUser";
import { useDispatch, useSelector } from "react-redux";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import deleteUser from "../../service/api/user/deleteUserById";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import { lblEmail, lblPhoneNumber, txtAction, txtCreatedDate, txtDashboard, txtDeleteAccountConfirmation, txtLastLogin, txtName, txtNoRecordsFound, txtRole } from "../../dataBaseFile/label";
import { btnAddUser, btnCheckWaitingUsers, btnFeedback } from "../../dataBaseFile/alert";
import verifyUserApi from "../../service/api/user/verifyUser";
import { FaSearch, FaUserCog } from "react-icons/fa";
import { setCurrentPage, setImpersonateAccessToken, setImpersonateFlag, setImpersonateRefreshToken, setImpersonateRoleId, setImpersonateUserId, setUserDetails } from "../../feature/userData/userData";
import { userById } from "../../service/api/user/userById";
import { LuArrowUpDown } from "react-icons/lu";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import SkeletonDivElement from "../../component/skeletonTableRow/skeletonDivElement"
import { resendCompanyInvitationApi } from "../../service/api/companies/resendCompanyInvitation";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import acceptCompanyJoinRequestApi from "../../service/api/companies/acceptCompanyJoinRequest";
import SelectPeriodFilter from "../../jsx/components/fields/selectPeriodFilter";
import deleteCompanyInvitationApi from "../../service/api/companies/deleteCompanyInvitation";
import cancelCompanyInvitationApi from "../../service/api/companies/cancelCompanyInvitation";
import { apiGetRegisteredCompanies } from "../../service/api/companies/getRegisteredCompanies";
import SelectStateCompanies from "../../jsx/components/fields/selectStateCompanies";
import InputField from "../../jsx/components/fields/inputField";
import updateUserCreditsApi from "../../service/api/user/updateUserCredits";
import resetHomeSetupApi from "../../service/api/homeMaintenance/resetHomeSetup";
import { sendPushNotificationApi } from "../../service/api/messaging/sendPushNotification";
import { sendEmailApi } from "../../service/api/messaging/sendEmail";
import { sendTextMessageApi } from "../../service/api/messaging/sendTextMessage";
import TextArea from "../../jsx/components/fields/textArea";
import TextEditor from "../../component/textEditor/textEditor";
import { getWorkInformation } from "../../service/api/professional/getWorkInformation";
import SkeletonForServices from "../../component/skeletonTableRow/skeletonForServices";
import { getDocuments } from "../../service/api/professional/getDocuments";
const AdminDashboard = () => {
  const nevigate = useNavigate();
  const { role, permissionArr, impersonateFlag } = useSelector((state) => state.user);
  const permissionArray = permissionArr[0] || []
  const [basicModal, setBasicModal] = useState(false);
  const [initiColor, setInitiColor] = useState(true);
  const [sortingCol, setSortingCol] = useState(true);

  const [skeltonVal, setSkeltonVal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPage, setTotalPage] = useState(1);
  const [elements, setElements] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [deletingId, setDeletingId] = useState(false);
  const [sortByValue, setSortByValue] = useState("DESC");
  const [columnName, setColumnName] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [totalNoRecord, setTotalNoRecord] = useState(100);
  const [flag, setFlag] = useState(false);
  const [handleToaster, setHandleToaster] = useState(false);
  const [toasterType, setToasterType] = useState();
  const [resMessage, setResMessage] = useState("");
  const [firstCheck, setFirstCheck] = useState(false);
  const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);
  const [userVerified, setUserVerified] = useState(0)
  const [impersonateModal, setImpersonateModal] = useState(false)
  const [impersonateId, setImpersonateId] = useState()

  const [filtreBox, setFiltreBox] = useState(false);
  const [filtreValue, SetFiltreValue] = useState(1);

  const [allUsers, setAllUsers] = useState(0);
  const [signedUpUsers, setSignedUpUsers] = useState(0);
  const [loggedInUsers, setLoggedInUsers] = useState(0);

  const [particularUserRole, setParticularUserRole] = useState('');
  const [particularUserRolesArr, setParticularUserRolesArr] = useState([]);

  const [signInSignUpFilter, setSignInSignUpFilter] = useState(1);

  const [isExpandedUserId, setIsExpandedUserId] = useState('');
  const [userFilter, setUserFilter] = useState('2');
  const userTypesArr = [
    { id: "2", name: "All users" },
    { id: "0", name: "Registered users" },
    { id: "1", name: "Invited users" },
  ]

  const [periodRangeFilter, setPeriodRangeFilter] = useState('6');
  const periodRangeArr = [
    { id: "6", name: "All" },
    { id: "1", name: "Last 7 days" },
    { id: "2", name: "Last 1 month" },
    { id: "3", name: "Last 3 months" },
    { id: "4", name: "Last 6 months" },
    { id: "5", name: "Last 1 year" },
  ]

  const [userRoleFilter, setUserRoleFilter] = useState('0');
  const userRoleArr = [
    { id: "0", name: "All" },
    { id: "1", name: "Professional" },
    { id: "2", name: "Customer" },
    { id: "3", name: "Super admin" },
    { id: "4", name: "Company admin" },
  ]

  const [companiesList, setCompaniesList] = useState([])
  const [companyIdSuper, setCompanyIdSuper] = useState('');
  const [particularUserDetails, setParticularUserDetails] = useState({})
  const [numberOfCredits, setNumberOfCredits] = useState(``);
  const [isNumberOfCreditsErr, setIsNumberOfCreditsErr] = useState(false);
  const [addCreditsLoading, setAddCreditsLoading] = useState(false);
  const [addCreditsModalTrigger, setAddCreditsModalTrigger] = useState(false);

  const [resetHomeAreasModalTrigger, setResetHomeAreasModalTrigger] = useState(false);
  const [resetHomeAreasLoading, setResetHomeAreasLoading] = useState(false);

  const [sendNotificationModalTrigger, setSendNotificationModalTrigger] = useState(false);

  const [isShowMoreDetails, setIsShowMoreDetails] = useState(false);

  const [proExpertiseArr, setProExpertiseArr] = useState([]);
  const [proExpertiseLoading, setProExpertiseLoading] = useState(false);

  const [proDocumentsArr, setProDocumentsArr] = useState([]);
  const [proDocumentsLoading, setProDocumentsLoading] = useState(false);

  const handleShowSendNotificationModal = (element) => {
    setSendNotificationModalTrigger(true);
    setParticularUserDetails(element);
    const rolesUserHave = element.roles.map((item) => {
      return {
        id: item.role_id_ids,
        name: item.role_display_name_chr
      }
    }
    )
    setParticularUserRolesArr(rolesUserHave);
    setParticularUserRole(rolesUserHave[0]?.id);


  }

  useEffect(() => {
    console.log(particularUserRolesArr, "rolesUserHave");
    console.log(particularUserRole, "particularUserRole");
    console.log(particularUserDetails?.user_id_ids, "particularUserDetails user_id_ids");
  }, [particularUserRolesArr, particularUserRole, particularUserDetails]);

  const handleCloseSendNotificationModal = () => {
    setSendNotificationModalTrigger(false);
    setParticularUserDetails({});
  }

  const handleShowAddCreditsModal = (element) => {
    setAddCreditsModalTrigger(true);
    setParticularUserDetails(element);
  }

  const handleCloseAddCreditsModal = () => {
    // onLoadData();
    setAddCreditsModalTrigger(false);
    setParticularUserDetails({});
    setNumberOfCredits(``)
    setIsNumberOfCreditsErr(false)
  }


  useEffect(() => {
    if (permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) {
      const getComapnies = new FormData();
      getComapnies.append("user_id_ids", localStorage.getItem("user_id"));
      getComapnies.append("pagination_flag", 0);
      // getComapnies.append("page_index", page);
      // getComapnies.append("page_size", pageSize);
      // getComapnies.append("sorting_order", sortByValue);
      // getComapnies.append("sorting_column_name", columnName);
      // getComapnies.append("search_area", searchValue);
      dispatch(
        apiGetRegisteredCompanies(getComapnies, (res) => {
          // setElements(res.data.data);
          const defaultCompany = { company_id_ids: '', company_name_chr: 'All' };
          setCompaniesList([defaultCompany, ...res.data.data])
        }, (err) => { })
      );
    }
  }, [])

  const percentage = 70;

  const tooltipDelete = (
    <Tooltip id="tooltip">
      <strong>Delete</strong>
    </Tooltip>
  );
  const tooltipEdit = (
    <Tooltip id="tooltip">
      <strong>Edit</strong>
    </Tooltip>
  );
  const tooltipVerify = (
    <Tooltip id="tooltip">
      <strong>Verify</strong>
    </Tooltip>
  );

  useEffect(() => {
    dispatch(setCurrentPage("Admin"));
  }, []);


  // With new logic
  const [expandedRow, setExpandedRow] = useState(null);

  const handleToggle = (rowIndex) => {
    if (rowIndex === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowIndex);
    }
  };

  // Modal triggers for the service requests details
  const [show, setShow] = useState(false);

  // Modal triggers for the service requests details
  const [showCallDetails, setShowCallDetails] = useState(false);

  const handleCloseCallDetails = () => setShowCallDetails(false);
  const handleShowCallDetails = (e) => {
    e.stopPropagation();
    setShowCallDetails(true);
  };

  // Modal triggers for the Add user by admin
  const [showAddUser, setShowAddUser] = useState(false);

  const handleCloseAddUser = () => {
    setShowAddUser(false)
    onLoadData()
  };
  const handleShowAddUser = (e) => {
    e.stopPropagation();
    setShowAddUser(true);
  };

  // Modal triggers for the Particular user details by admin
  const [showParticularUserDetails, setShowParticularUserDetails] =
    useState(false);

  const handleCloseParticularUserDetails = () => {
    onLoadData()
    setShowParticularUserDetails(false);
  };

  const handleShowParticularUserDetails = (e) => {
    e.stopPropagation();
    setShowParticularUserDetails(true);
  };

  // Redirect to the waiting user dashboard
  const checkWaitingUsers = () => {
    nevigate("/waitingUserDashboard");
  };

  // Redirect to the waiting user dashboard
  const checkFeedbackList = () => {
    nevigate("/feedbackList");
  };

  // Dummy call check for toaster

  const getCallHistoryDetails = (res) => {

    // const newElements = [...elements, ...res.data];
    // const uniqueElements = Array.from(
    //   new Set(newElements.map(JSON.stringify))
    // ).map(JSON.parse);


    setElements(res.data);
    setTotalNoRecord(res.total_count);


    if (res.total_count % pageSize === 0) {
      setTotalPage(parseInt(res.total_count / pageSize));
    } else {
      setTotalPage(parseInt(res.total_count / pageSize + 1));
    }

  };

  function onLoadData() {

    setSkeltonVal(true);
    setCustomeSkeletonLoading(true);

    const data = new FormData();
    data.append("user_id_ids", localStorage.getItem("user_id"));
    data.append("pagination_flag", 1);
    data.append("page_index", page);
    data.append("page_size", pageSize);
    data.append("sorting_order", sortByValue);
    data.append("sorting_column_name", columnName);
    data.append("search_area", searchValue);
    data.append("invitation_record_flag", userFilter);
    periodRangeFilter && data.append("period_options", periodRangeFilter);
    data.append("user_list_options", signInSignUpFilter);
    userRoleFilter && data.append("role_id_int", userRoleFilter);
    data.append("company_id_ids", companyIdSuper);
    startDate && data.append("from_date_dtm", startDate);
    endDate && data.append("to_date_dtm", endDate);

    dispatch(
      registeredUser(data, (res) => {
        setSkeltonVal(false);
        setElements(res.data.data);
        getCallHistoryDetails(res.data);
        setAllUsers(res?.data?.all_users_count)
        setSignedUpUsers(res?.data?.signed_up_users_count)
        setLoggedInUsers(res?.data?.logged_in_users_count)
        setCustomeSkeletonLoading(false);
        setTotalNoRecord(res.data.total_count);
        if (res.data.total_count % pageSize === 0) {
          setTotalPage(parseInt(res.data.total_count / pageSize));
        } else {
          setTotalPage(parseInt(res.data.total_count / pageSize + 1));
        }

      }, (err) => {
        setCustomeSkeletonLoading(true);
      })
    );

    return;
  }

  const handleColumnName = (name) => {
    setSortingCol(false);
    setColumnName(name);

    if (sortByValue === "ASC") {
      setSortByValue("DESC");
    }
    if (sortByValue === "DESC") {
      setSortByValue("ASC");
    }
  };

  const handleOrderValue = (order) => {
    setSortByValue(order);
  };

  const handleSearch = (e) => {
    setPage(1);
    const ele = []
    setElements(ele);
    if (searchValue.trim().length >= 2) {
      onChangePage(1)
      setColumnName('')
    }
    setSearchValue(e.target.value)
  };

  const handleChangeRowsPerPage = (e) => {
    // console.log(e)
    setSearchValue("");
    setPage(1);
    setPageSize(e.target.value);
  };

  const onChangePage = (e, p) => {
    // setPage(p);
    setPage(e);
  };

  useEffect(() => {
    onLoadData();
  }, [sortByValue, pageSize, page, columnName, filtreValue, userFilter, periodRangeFilter, signInSignUpFilter, userRoleFilter, companyIdSuper]);

  useEffect(() => {
    // if (searchValue.trim().length > 2) {
    //   const ele = [];
    //   setPage(1);
    //   setElements(ele);
    //   setFlag(true);
    //   const timeOutId = setTimeout(onLoadSearch, 1000);
    //   return () => clearTimeout(timeOutId);
    // } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
    //   if (flag) {
    //     onLoadData();
    //   }
    // }

    if (searchValue.trim().length > 2) {
      setFlag(true);
      const timeOutId = setTimeout(onLoadSearch, 1000);
      return () => clearTimeout(timeOutId);
    } else if (searchValue.trim().length === 0) {
      if (flag) {
        onLoadSearch();
      }
    }
  }, [searchValue]);

  function onLoadSearch() {
    setSkeltonVal(true);
    var data = {
      user_id_ids: localStorage.getItem("user_id"),
      pagination_flag: 1,
      page_index: 1,
      page_size: pageSize,
      sorting_order: sortByValue,
      sorting_column_name: "",
      search_area: searchValue,
      invitation_record_flag: userFilter,
      period_options: periodRangeFilter ? periodRangeFilter : 0,
      user_list_options: signInSignUpFilter,
      role_id_int: userRoleFilter ? userRoleFilter : 0,
      company_id_ids: companyIdSuper,
      from_date_dtm: startDate,
      to_date_dtm: endDate,
    };
    dispatch(
      registeredUser(data, (res) => {
        setSkeltonVal(false);
        getCallHistoryDetails(res.data);
        setAllUsers(res?.data?.all_users_count)
        setSignedUpUsers(res?.data?.signed_up_users_count)
        setLoggedInUsers(res?.data?.logged_in_users_count)
        // setElements(res.data.data);
        // setTotalNoRecord(res.data.total_count);
        // if (res.data.total_count % pageSize === 0) {
        //   setTotalPage(parseInt(res.data.total_count / pageSize));
        // } else {
        //   setTotalPage(parseInt(res.data.total_count / pageSize + 1));
        // }

      })
    );
  }


  const [deleteUserLoading, setDeleteUserLoading] = useState(false);
  function deleteAccount() {
    let details = {
      user_id_ids: deletingId,
    };

    setDeleteUserLoading(true);
    dispatch(
      deleteUser(
        details,
        (res) => {

          setDeleteUserLoading(false);

          let indexToDelete = elements.findIndex(user => user.user_id_ids === deletingId);
          elements.splice(indexToDelete, 1)

          setBasicModal(false);
          setToasterType("success");

          setResMessage(res.data.message);
          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);

          onLoadData();
        },
        (res) => {
          setDeleteUserLoading(false);
          setBasicModal(false);
          setToasterType("error");
          setResMessage(res.data.message);
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  }

  const [verifyLoading, setVerifyLoading] = useState(false)
  const [isVerifyingUserId, setIsVerifyingUserId] = useState('')
  function verifyUserById(id, index, isVerifiedFlag) {
    setVerifyLoading(true)
    let data = {
      user_id_ids: id,
      user_verification_flag: isVerifiedFlag ? 0 : 1
    }

    dispatch(verifyUserApi(data, (res) => {


      setElements(prevUsers => {
        const updatedUsers = [...prevUsers];
        updatedUsers[index].is_verified_ysn = isVerifiedFlag ? 0 : 1;
        return updatedUsers;
      });

      setIsVerifyingUserId('')

      setVerifyLoading(false)
      setToasterType("success");
      setResMessage(res.data.message);
      // setHandleToaster(true);

      // onLoadData()
    }, (err) => {
      setVerifyLoading(false)
      setToasterType("error");
      setResMessage(err.data.message);
      setHandleToaster(true);
      onLoadData()
    }))
  }

  const showUserDetails = (e, element) => {
    e.preventDefault();
    localStorage.setItem("user_id_for_admin", element.user_id_ids);
    navigate('/particularUserDetailsForAdminPage');
  }
  function handleRegisteredCompanies() {
    navigate('/registeredCompanies');
  }
  function handlePermissions() {
    navigate('/permissions');
  }
  function impersonateUserById() {

    setImpersonateModal(false)
    dispatch(setImpersonateFlag(true))
    dispatch(setImpersonateUserId(localStorage.getItem("user_id")))
    dispatch(setImpersonateAccessToken(localStorage.getItem("access_token")))
    dispatch(setImpersonateRefreshToken(localStorage.getItem("refresh_token")))
    dispatch(setImpersonateRoleId(localStorage.getItem("roleId")))
    localStorage.setItem("user_id", impersonateId)
    let details = {
      user_id_ids: localStorage.getItem("user_id"),
      role_id_int: 0,
      user_impersonate_flag: 1,
    };

    dispatch(
      userById(
        details,
        (res) => {

          dispatch(setUserDetails(res.data.data))
          console.log(res.data)
          localStorage.setItem("access_token", res.data.access_token)
          localStorage.setItem("refresh_token", res.data.refresh_token)
          localStorage.setItem("roleId", res.data.data.role_id_ids)
          navigate("/dashboard")
        },
        (err) => { }
      )
    );

  }

  function handleGetUserById(e) {

  }




  function handleSetFiltreValue(v) {
    SetFiltreValue(v);
    const ele = [];
    setPage(1);
    setElements(ele);
    if (v === 1) {
      setSortByValue("DESC");
    } else if (v === 2) {
      setSortByValue("ASC");
    }
  }

  function handleOpenFiltreBox() {
    setFiltreBox(!filtreBox);
  }

  const searchAreaVal = (e) => {
    // setSearchArea(e.target.value)
    // if (searchArea.trim().length >= 2) {
    //     onChangePage(1)
    // }

    setSearchValue(e.target.value)
    if (searchValue.trim().length >= 2) {
      onChangePage(1)
    }
  }

  // Format the unix time in given format
  function formatUnixTimestamp(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);

    const month = date.toLocaleString('default', { month: 'short' });
    const day = date.getDate();
    let hour = date.getHours();
    const minute = date.getMinutes();

    const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
    const amPm = hour < 12 ? 'am' : 'pm';
    const minuteFormatted = minute < 10 ? `0${minute}` : minute;

    return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
  }

  const [invitationLoading, setInvitationLoading] = useState(false);
  const [companyInvitationId, setCompanyInvitationId] = useState('')
  const [companyInvitationObj, setCompanyInvitationObj] = useState({})
  const handleResendCompanyInvitation = (invitationId) => {
    setInvitationLoading(true);
    let formData = new FormData();
    formData.append("invitation_id_ids", invitationId);

    dispatch(
      resendCompanyInvitationApi(
        formData,
        (res) => {
          setResMessage(res.data.message);
          setToasterType("success");
          setInvitationLoading(false);
          onLoadData();
          setCompanyInvitationId("");

          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 4000);
        },
        (err) => {
          setResMessage(err.data.message);
          setToasterType("error");
          setHandleToaster(true);
          setInvitationLoading(false);
          setCompanyInvitationId("");

          setTimeout(() => {
            setHandleToaster(false);
          }, 4000);
        }
      )
    );

  }

  const [companyAdminApproveModal, setCompanyAdminApproveModal] = useState(false)
  const handleOpenCompanyAdminApproveModal = () => {
    setCompanyAdminApproveModal(true)
  }

  const handleCloseCompanyAdminApproveModal = () => {
    setCompanyAdminApproveModal(false);
    setCompanyInvitationObj({})
  }

  const handleCompanyAdminApproveRequest = () => {
    let data = new FormData();
    data.append('company_invitation_token', companyInvitationObj?.company_invitation_code);

    setInvitationLoading(true);

    dispatch(acceptCompanyJoinRequestApi(data, (res) => {

      setResMessage(res?.data?.message);
      setInvitationLoading(false);
      handleCloseCompanyAdminApproveModal();
      onLoadData();

    }, (err) => {
      console.log(err, "err acceptCompanyInvitationApi");
      // setCustomLoading(false);

      setInvitationLoading(false);

      setResMessage(err?.data?.message);
      setToasterType("error");

      setHandleToaster(true);
      setTimeout(() => {
        setHandleToaster(false);
      }, 5000);
    }))
  }



  const handleUserFilter = (e) => {
    setUserFilter(e.target.value);
  }

  const handlePeriodRangeFilter = (e) => {
    setPeriodRangeFilter(e.target.value);
  }

  const handleUserRoleFilter = (e) => {
    setUserRoleFilter(e.target.value);
  }

  // Delete invitation functions
  const [deleteInvitationModalTrigger, setDeleteInvitationModalTrigger] = useState(false);
  const handleOpenDeleteInvitationModal = (invitationId) => {
    setDeleteInvitationModalTrigger(true);
    setCompanyInvitationId(invitationId);
  }

  const handleCloseDeleteInvitationModal = () => {
    setDeleteInvitationModalTrigger(false);
    setCompanyInvitationId('');
  }
  const handleDeleteCompanyInvitationFn = () => {
    setInvitationLoading(true);
    let data = {
      invitation_id_ids: companyInvitationId
    }

    dispatch(deleteCompanyInvitationApi(data, (res) => {
      setResMessage(res?.data?.message);
      setInvitationLoading(false);
      // setHandleToaster(true);
      // setTimeout(() => {
      //   setHandleToaster(false);
      // }, 5000);
      handleCloseDeleteInvitationModal();
      onLoadData();
    }, (err) => {
      setResMessage(err?.data?.message);
      setInvitationLoading(false);
      setToasterType("error");
      setHandleToaster(true);
      setTimeout(() => {
        setHandleToaster(false);
      }, 5000);
    }))
  }

  // Cancel invitations functions
  const [cancelInvitationModalTrigger, setCancelInvitationModalTrigger] = useState(false);
  const handleOpenCancelInvitationModal = (invitationId) => {
    setCancelInvitationModalTrigger(true);
    setCompanyInvitationId(invitationId);
  }

  const handleCloseCancelInvitationModal = () => {
    setCancelInvitationModalTrigger(false);
    setCompanyInvitationId('');
  }

  const handleCancelCompanyInvitationFn = () => {
    setInvitationLoading(true);
    let data = {
      invitation_id_ids: companyInvitationId
    }

    dispatch(cancelCompanyInvitationApi(data, (res) => {
      setResMessage(res?.data?.message);
      setInvitationLoading(false);
      // setHandleToaster(true);
      // setTimeout(() => {
      //   setHandleToaster(false);
      // }, 5000);
      handleCloseCancelInvitationModal();
      onLoadData();
    }, (err) => {
      setResMessage(err?.data?.message);
      setInvitationLoading(false);
      setToasterType("error");
      setHandleToaster(true);
      setTimeout(() => {
        setHandleToaster(false);
      }, 5000);
    }))
  }

  function handleCompaniesSelectValue(e) {
    setCompanyIdSuper(e.target.value)
  }

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Using useRef for both date pickers
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  const handleStartDateClick = () => {
    startDateRef.current.showPicker();
  };

  const handleEndDateClick = () => {
    endDateRef.current.showPicker();
  };

  const handleStartDateChange = () => {
    // setStartDate(startDateRef.current.value);
    const selectedDate = startDateRef.current.value;
    const unixStartDate = Math.floor(new Date(selectedDate).getTime() / 1000);
    setStartDate(unixStartDate);
  };

  const handleEndDateChange = () => {
    // setEndDate(endDateRef.current.value);
    const selectedDate = endDateRef.current.value;
    const unixEndDate = Math.floor(new Date(selectedDate).getTime() / 1000);
    setEndDate(unixEndDate);
  };

  // console.log(startDate, "startDate", endDate, "endDate");

  const [isDatesClear, setIsDatesClear] = useState(false);
  const clearDatesFilter = () => {
    setStartDate(null);
    setEndDate(null);
    startDateRef.current.value = ''; // Clear the actual input field value
    endDateRef.current.value = ''; // Clear the actual input field value
    setIsDatesClear(prev => !prev)
    // onLoadData();
  }

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    onLoadData();
  }, [isDatesClear]);

  const [isMounted, setIsMounted] = useState(true);

  const clearAllFilters = () => {
    clearDatesFilter();
    setPeriodRangeFilter('6');
    setUserRoleFilter('0');
    setCompanyIdSuper('');
    setSearchValue('');
    setSignInSignUpFilter(1);

    setIsMounted(false);
    setTimeout(() => setIsMounted(true), 0);
  }



  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });


  // Add credits to user functions here


  const handleNumberOfCredits = (e) => {
    setIsNumberOfCreditsErr(false)
    setNumberOfCredits(e.target.value.replace(/[^\d.]/g, ''));
  }

  const handleNumberOfCreditsBlurCheck = () => {
    if (numberOfCredits == 0 || isNaN(numberOfCredits) || numberOfCredits === '') {
      setIsNumberOfCreditsErr(true);
    }
  }

  const handleAddCredits = (e) => {
    e?.preventDefault();
    setAddCreditsLoading(true);
    if (numberOfCredits == 0 || isNaN(numberOfCredits) || numberOfCredits === '') {
      setIsNumberOfCreditsErr(true);
      setAddCreditsLoading(false);
    } else {
      let details = new FormData();

      details.append("user_id_ids", particularUserDetails?.user_id_ids);
      details.append("number_of_credits_float", parseInt(numberOfCredits * 100));
      details.append("operation_int", 0);

      dispatch(
        updateUserCreditsApi(
          details,
          (res) => {
            // console.log(res)
            setAddCreditsLoading(false);
            setResMessage(res.data.message)
            setToasterType("success")

            handleCloseAddCreditsModal();

            onLoadData();

            // setHandleToaster(true);
            // setTimeout(() => {
            //     setHandleToaster(false);
            // }, 11000);


          },
          (res) => {
            // console.log(res)
            setResMessage(res.data.message)
            setToasterType("error");

            setAddCreditsLoading(false);

            setHandleToaster(true);
            setTimeout(() => {
              setHandleToaster(false);
            }, 11000);
          }
        )
      )
    }
  }

  const handleResetHomeSetup = () => {
    let details = {
      user_id_ids: deletingId,
    };

    setResetHomeAreasLoading(true);
    dispatch(
      resetHomeSetupApi(
        details,
        (res) => {

          setResetHomeAreasLoading(false);
          setDeletingId('');

          setResetHomeAreasModalTrigger(false);
          setToasterType("success");

          setResMessage(res.data.message);
          // setHandleToaster(true);
          // setTimeout(() => {
          //   setHandleToaster(false);
          // }, 11000);

          // onLoadData();
        },
        (res) => {
          setResetHomeAreasLoading(false);
          setToasterType("error");
          setResMessage(res.data.message);
          setHandleToaster(true);
          setTimeout(() => {
            setHandleToaster(false);
          }, 11000);
        }
      )
    );
  }

  // Send notification to particular user by super admin
  const [attachedImage0, setAttachedImage0] = useState(null);
  const [notificationTitle, setNotificationTitle] = useState(``);
  const [notificationDescription, setNotificationDescription] = useState(``);

  const [notificationTitleErr, setNotificationTitleErr] = useState(false);
  const [notificationDescriptionErr, setNotificationDescriptionErr] = useState(false);

  const [sendNotificationLoading, setSendNotificationLoading] = useState(false);

  const [openDoc, setOpenDoc] = React.useState(false);
  const [imageAttachURL, setImageAttachURL] = useState('');
  const [notesMessage, setNotesMessage] = useState("");

  const [sendNotificationsNav, setSendNotificationsNav] = useState(1);


  useEffect(() => {
    setAttachedImage0(null);
    setNotificationTitle(``);
    setNotificationDescription(``);
    setNotificationTitleErr(false);
    setNotificationDescriptionErr(false);
  }, [sendNotificationsNav]);


  const handleOpenDoc = () => {
    setOpenDoc(true);
  }
  const handleCloseDoc = () => {
    setOpenDoc(false);
    setNotesMessage('');
  }

  const handleChangeNotificationTitle = (e) => {
    setNotificationTitleErr(false);
    setNotificationTitle(e?.target?.value);
  };

  const handleChangeNotificationTitleBlurCheck = () => {
    if (notificationTitle === ``) {
      setNotificationTitleErr(true);
    }
  }

  const handleChangeNotificationDescription = (e) => {
    setNotificationDescriptionErr(false);
    setNotificationDescription(e?.target?.value);
  };

  const handleChangeNotificationDescriptionBlurCheck = () => {
    if (notificationDescription === ``) {
      setNotificationDescriptionErr(true);
    }
  }

  // Attachment Upload 1
  const attachedImage0Ref = useRef();
  const [uploadAttachedImage0, setUploadAttachedImage0] = useState(null);
  const [uploadImgLoading, setUploadImgLoading] = useState(false);


  const handleClickAttachedImage0 = () => {
    attachedImage0Ref.current.click();
  }
  async function handleAttachedImage0(e) {
    if (e.target.files) {
      // setUploadAttachedImage0(e.target.files[0]);
      // setAttachedImage0(URL.createObjectURL(e.target.files[0]))

      const file = e.target.files[0];

      if (file && file.size > 1024 * 1024) { // Check if the file size is greater than 1 MB
        setUploadImgLoading(true);
        try {
          const options = {
            maxSizeMB: 0.5, // Maximum size in MB
            maxWidthOrHeight: 1920, // Maximum width or height
            useWebWorker: true, // Use web worker for faster compression
          };
          const compressedFile = await imageCompression(file, options);
          // console.log('Original file size:', (file.size / 1024 / 1024).toFixed(2), 'MB');
          // console.log('Compressed file size:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');
          // setSelectedFile(compressedFile);
          setUploadAttachedImage0(compressedFile);
          setAttachedImage0(URL.createObjectURL(compressedFile));
          setUploadImgLoading(false);
        } catch (error) {
          // console.error('Error compressing the image:', error);
          setUploadImgLoading(false);
        }
      } else {
        setUploadAttachedImage0(file);
        setAttachedImage0(URL.createObjectURL(file));
      }
    }
  }

  function deleteAttachedImage0() {
    setUploadAttachedImage0(null);
    setAttachedImage0(null)
  }


  const handleSendNotification = (e) => {
    // e.preventDefault();

    if (notificationTitle === '') {
      setNotificationTitleErr(true);
    }

    if (notificationDescription === '') {
      setNotificationDescriptionErr(true);
    }



    if (notificationTitle !== '' && notificationDescription !== '') {
      setSendNotificationLoading(true);
      let formData = new FormData();


      formData.append("title", notificationTitle);
      formData.append("body", notificationDescription);
      formData.append("user_id", particularUserDetails?.user_id_ids);
      particularUserRole && formData.append("role_id", particularUserRole);
      (uploadAttachedImage0 != null) && formData.append("image", uploadAttachedImage0);

      dispatch(sendPushNotificationApi(formData, (res) => {
        setSendNotificationLoading(false);
        // console.log(res.data.data, "Create update project data");

        setResMessage(res.data.message)
        setToasterType("success")

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);

        handleClearSendNotification();

      }, (err) => {
        setSendNotificationLoading(false);

        setResMessage(err.data.message)
        setToasterType("error")

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }))
    }




  }

  const handleSendEmailNotification = (e) => {
    // e.preventDefault();

    if (notificationTitle === '') {
      setNotificationTitleErr(true);
    }

    if (notificationDescription === '') {
      setNotificationDescriptionErr(true);
    }

    if (notificationTitle !== '' && notificationDescription !== '') {
      setSendNotificationLoading(true);
      let formData = new FormData();

      formData.append("subject", notificationTitle);
      formData.append("body", notificationDescription);
      formData.append("user_id", `${particularUserDetails?.user_id_ids}`);
      particularUserRole && formData.append("role_id", `${particularUserRole}`);
      (uploadAttachedImage0 != null) && formData.append("attachment", uploadAttachedImage0);

      dispatch(sendEmailApi(formData, (res) => {
        setSendNotificationLoading(false);
        // console.log(res.data.data, "Create update project data");

        setResMessage(res.data.message);
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);

        handleClearSendNotification();

      }, (err) => {
        setSendNotificationLoading(false);

        setResMessage(err.data.message);
        setToasterType("error");

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }))
    }
  }

  const handleSendTextMessageNotification = (e) => {
    // e.preventDefault();

    // if (notificationTitle === '') {
    //   setNotificationTitleErr(true);
    // }

    if (notificationDescription === '') {
      setNotificationDescriptionErr(true);
    }

    if (notificationDescription !== '') {
      setSendNotificationLoading(true);
      let formData = new FormData();

      // formData.append("subject", notificationTitle);
      formData.append("body", notificationDescription);
      formData.append("user_id", particularUserDetails?.user_id_ids);
      particularUserRole && formData.append("role_id", particularUserRole);
      // (uploadAttachedImage0 != null) && formData.append("image", uploadAttachedImage0);

      dispatch(sendTextMessageApi(formData, (res) => {
        setSendNotificationLoading(false);
        // console.log(res.data.data, "Create update project data");

        setResMessage(res.data.message);
        setToasterType("success");

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);

        handleClearSendNotification();

      }, (err) => {
        setSendNotificationLoading(false);

        setResMessage(err.data.message);
        setToasterType("error");

        setHandleToaster(true);
        setTimeout(() => {
          setHandleToaster(false);
        }, 11000);
      }))
    }
  }

  const handleClearSendNotification = () => {
    setAttachedImage0(null);
    setNotificationTitle(``);
    setNotificationDescription(``);
    setUploadAttachedImage0(null);
    setUserRoleFilter('0');

    setNotificationTitleErr(false);
    setNotificationDescriptionErr(false);

    setIsMounted(false);
    setTimeout(() => setIsMounted(true), 0);

    handleCloseSendNotificationModal();

    setParticularUserRole('');
    setParticularUserRolesArr([]);
  }

  const handleParticularUserRoleFilter = (e) => {
    setParticularUserRole(e.target.value);
  }

  // Show professional expertise and documents functions
  const getWorkInfoFn = () => {
    let details = {
      // user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
      user_id_ids: isExpandedUserId

    }

    setProExpertiseLoading(true)

    dispatch(
      getWorkInformation(details, (res) => {
        // console.log(res, "user work Data comes here")

        res?.data?.data?.professional_expertise_info && setProExpertiseArr(res?.data?.data?.professional_expertise_info)
        setProExpertiseLoading(false)
      }),
      (res) => {
        setProExpertiseLoading(false)
      }
    )
  }

  const getProDocumentsFn = () => {
    let details = {
      // user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
      user_id_ids: isExpandedUserId

    }

    setProDocumentsLoading(true)

    dispatch(
      getDocuments(details,
        (res) => {
          // console.log(res)
          setProDocumentsLoading(false)
          setProDocumentsArr(res?.data?.data?.pro_documents)
        },
        (res) => {
          setProDocumentsLoading(false)
        }
      )
    )

  }


  return (
    <>
      {/* New Admin dashboard */}
      <div className="row mx-3 mb-5" style={{}}>
        <div className="col-12 px-0">



          {/* <input type="date" id="start" name="trip-start" /> */}

          <div className="row mx-0 p-3">
            <div className="col-lg-6 px-0 ps-2 d-flex align-item-center justify-content-start">
              <span className="fs-4 fw-bold text-black">{"Dashboard"}</span>
            </div>

            <div className="col-lg-6 px-0 pe-2 d-flex align-item-center justify-content-end">
              {/* {(permissionArray.includes("VIEW COMPANY USERS")) &&
                <button
                  onClick={(e) => {
                    navigate("/companyRequests");
                  }}
                  className="admin-add-user px-3"
                  style={{ width: 'auto' }}
                  variant="light btn-rounded"
                >
                  {"Company invitations"}
                </button>
              } */}

              {(permissionArray.includes("CREATE USER")) &&
                <button
                  onClick={(e) => handleShowAddUser(e)}
                  className="admin-add-user px-3"
                  style={{ width: 'auto' }}
                  variant="light btn-rounded"
                >

                  <i
                    className="bi bi-plus-circle-fill"
                    style={{ marginRight: "10px" }}></i>
                  {(permissionArray.includes("ASSIGN COMPANY")) ? btnAddUser : "Add team member"}
                </button>
              }
            </div>
          </div>


          {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
            <div className="row mx-0 mb-3">
              <div className="col-12 px-0 d-flex align-item-center justify-content-end">

                <div
                  className="d-flex flex-column shadow rounded-2 cursor-pointer bg-white me-3"
                  style={{ width: '140px' }}
                  onClick={(e) => { handleStartDateClick() }}
                >
                  <div className="fs-7 d-flex justify-content-center align-items-center bg-primary rounded-top p-2 text-white font-w600">
                    <span className="me-2"><i className="bi bi-calendar-range"></i></span>
                    <span>{`Select start date`}</span>
                  </div>
                  <div className="d-flex justify-content-center align-items-center p-2">
                    <span className="font-w600 text-black">{
                      startDate ?
                        new Date(startDate * 1000).toLocaleDateString('en-US', {
                          month: 'short',
                          day: '2-digit',
                          year: 'numeric',
                        }) : '-'}</span>
                  </div>

                  {/* Hidden Input for Start Date */}
                  <input
                    type="date"
                    ref={startDateRef}
                    onChange={handleStartDateChange}
                    max={new Date().toISOString().split('T')[0]}
                    // style={{ display: 'none' }}
                    style={{ visibility: 'hidden', width: '0', height: '0' }}
                  />
                </div>

                <div
                  className="d-flex flex-column shadow rounded-2 cursor-pointer bg-white"
                  style={{ width: '140px' }}
                  onClick={(e) => { handleEndDateClick() }}
                >
                  <div className="fs-7 d-flex justify-content-center align-items-center bg-primary rounded-top p-2 text-white font-w600">
                    <span className="me-2"><i className="bi bi-calendar-range"></i></span>
                    <span>{`Select end date`}</span>
                  </div>
                  <div className="d-flex justify-content-center align-items-center p-2">
                    <span className="font-w600 text-black">{
                      endDate ?
                        new Date(endDate * 1000).toLocaleDateString('en-US', {
                          month: 'short',
                          day: '2-digit',
                          year: 'numeric',
                        }) : '-'}</span>
                  </div>

                  {/* Hidden Input for End Date */}
                  <input
                    type="date"
                    ref={endDateRef}
                    onChange={handleEndDateChange}
                    max={new Date().toISOString().split('T')[0]}
                    // style={{ display: 'none' }}
                    style={{ visibility: 'hidden', width: '0', height: '0' }}
                  />

                </div>

                {startDate && endDate &&
                  <div className="d-flex align-items-center justify-content-center mx-2">
                    <div className="tooltipCustom">
                      <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Apply date"}</span>
                      <span
                        className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                        onClick={(e) => onLoadData()}
                        style={{ height: '40px', width: '40px', }}
                      >
                        <i className="bi bi-check2-circle text-success" style={{ color: 'green', fontSize: '25px' }} />
                      </span>
                    </div>
                  </div>
                }

                {startDate && endDate &&
                  <div className="d-flex align-items-center justify-content-center mx-2">
                    <div className="tooltipCustom">
                      <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Clear date filter"}</span>
                      <span
                        className="font-w600 text-black overlay-action-btn cursor-pointer rounded-circle d-flex align-items-center justify-content-center"
                        onClick={(e) => clearDatesFilter()}
                        style={{ height: '40px', width: '40px', }}
                      >
                        <i className="bi bi-x-circle text-danger" style={{ fontSize: '25px' }} />
                      </span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
            <div className="row">
              {/* <div className="col-12 col-md-3 pe-md-2 mb-2">
                <div
                  className={`h-100 d-flex rounded p-2 cursor-pointer border-hovered ${signInSignUpFilter === 0 ? 'shadow-sm' : ''}`}
                  style={{ border: signInSignUpFilter === 0 ? '2px solid orange' : '2px solid #c8c4c487' }}
                  onClick={() => setSignInSignUpFilter(0)}
                >
                  <div className="d-flex align-items-center">
                    <div className="me-2" style={{ fontSize: '40px' }}>
                      <i className="bi bi-person-fill"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <div className="mb-1"><span className="fs-5 font-w600 text-black">{"All users"}</span></div>
                      <div><span className="fs-3 font-w600 text-black">{`${allUsers}`}</span></div>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="col-12 col-md-3 pe-md-2 mb-2">
                <div
                  className={`h-100 d-flex rounded p-2 cursor-pointer border-hovered ${signInSignUpFilter === 1 ? 'shadow-sm' : ''}`}
                  style={{ border: signInSignUpFilter === 1 ? '2px solid orange' : '2px solid #c8c4c487' }}
                  onClick={() => setSignInSignUpFilter(1)}
                >
                  <div className="d-flex align-items-center">
                    <div className="me-2" style={{ fontSize: '40px' }}>
                      <i className="bi bi-person-fill"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <div className="mb-1"><span className="fs-5 font-w600 text-black">{"Registered users"}</span></div>
                      <div><span className="fs-3 font-w600 text-black">{`${signedUpUsers}`}</span></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-md-3 pe-md-2 mb-2">
                <div
                  className={`h-100 d-flex rounded p-2 cursor-pointer border-hovered ${signInSignUpFilter === 2 ? 'shadow-sm' : ''}`}
                  style={{ border: signInSignUpFilter === 2 ? '2px solid orange' : '2px solid #c8c4c487' }}
                  onClick={() => setSignInSignUpFilter(2)}
                >
                  <div className="d-flex align-items-center">
                    <div className="me-2" style={{ fontSize: '40px' }}>
                      <i className="bi bi-person-fill"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <div className="mb-1"><span className="fs-5 font-w600 text-black">{"Logged in"}</span></div>
                      <div><span className="fs-3 font-w600 text-black">{`${loggedInUsers}`}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }




          <div className="mt-4 d-flex justify-content-start row">
            {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
              <div className=" col-sm-3 pe-sm-2" style={{ width: '' }}>
                {isMounted && <SelectStateCompanies
                  labelName={"Company"}
                  options={companiesList}
                  onChange={handleCompaniesSelectValue}
                  defaultValue={companyIdSuper}
                />}
              </div>
            }

            {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
              <div className=" col-sm-3 pe-sm-2" style={{ width: '' }}>
                {isMounted && <SelectPeriodFilter
                  labelName={`Filter by role`}
                  onChange={(e) => handleUserRoleFilter(e)}
                  defaultValue={userRoleFilter}
                  options={userRoleArr}
                  errorOccured={false}
                  errorMessage={""}
                />}
              </div>
            }

            {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
              <div className="col-sm-3 pe-sm-2" style={{ width: '' }}>
                {isMounted && <SelectPeriodFilter
                  labelName={`Filter by range`}
                  onChange={(e) => handlePeriodRangeFilter(e)}
                  defaultValue={periodRangeFilter}
                  options={periodRangeArr}
                  errorOccured={false}
                  errorMessage={""}
                />}
              </div>
            }

            {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) &&
              <div className="col-sm-3 pe-sm-2 d-flex" style={{ width: '' }}>
                <span
                  className="px-3 py-1 cursor-pointer text-primary fs-5 font-w600 rounded overlay-action-btn bg-light d-flex align-items-center justify-content-center"
                  style={{ height: '40px' }}
                  onClick={() => clearAllFilters()}
                >
                  {`Clear all `}
                </span>
              </div>
            }

            {(permissionArray.includes("VIEW COMPANY USERS")) &&
              <div className="col-sm-3" style={{ width: '' }}>
                <SelectPeriodFilter
                  labelName={`Filter by users`}
                  onChange={(e) => handleUserFilter(e)}
                  defaultValue={userFilter}
                  options={userTypesArr}
                  errorOccured={false}
                  errorMessage={""}
                />
              </div>
            }
          </div>


          <div className='my-3'>
            <PaginationAndSearching
              handleSearch={searchAreaVal}
              // searchValue={searchArea}
              searchValue={searchValue}
              defaultValue={pageSize}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              totalCount={totalPage}
              onChange={onChangePage}
            />
          </div>

          <Table responsive>

            <thead>
              <tr className='text-black bg-light'>
                <th
                  style={{ fontWeight: '700' }}
                >
                  {`Actions`}
                </th>
                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("first_name_chr") }}
                >
                  {`Name`}
                  <span className="ml-1">
                    {columnName === 'first_name_chr' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>
                <th
                  // className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                // onClick={() => { handleColumnName("role_id_ids") }}
                >
                  {`Role`}
                  {/* <span className="ml-1">
                    {columnName === 'role_id_ids' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span> */}
                </th>

                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("email_chr") }}
                >
                  {`Email`}
                  <span className="ml-1">
                    {columnName === 'email_chr' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>
                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("phone_number_int") }}
                >
                  {`Phone`}
                  <span className="ml-1">
                    {columnName === 'phone_number_int' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>


                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("created_date_dtm") }}
                >
                  {`Created on`}
                  <span className="ml-1">
                    {columnName === 'created_date_dtm' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>
                <th
                  className='cursor-pointer'
                  style={{ fontWeight: '700' }}
                  onClick={() => { handleColumnName("last_log_in_dtm") }}
                >
                  {`Last login`}
                  <span className="ml-1">
                    {columnName === 'last_log_in_dtm' ? (
                      <>
                        {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                        {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                      </>
                    )
                      :
                      (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                    }
                  </span>
                </th>

                <th></th>
              </tr>
            </thead>

            <tbody>
              {customeSkeletonLoading ?
                <SkeletonTableRow cols={8} /> :
                <>
                  {elements?.length > 0 ?
                    <>
                      {elements?.map((element, index) => {
                        return (
                          <>
                            <tr
                              className={`notification-rows font-w700 ${isExpandedUserId === element.user_id_ids ? "bg-primary text-white " : ""}`}
                              key={index}
                              style={{
                                cursor: element?.invitation_id_ids ? "default" : "pointer"
                              }}
                              onClick={() => {
                                // onRowClick(element)
                                setProExpertiseArr([]);
                                setIsShowMoreDetails(false);
                                if (!element?.invitation_id_ids) {
                                  if (element?.user_id_ids === isExpandedUserId) {
                                    setIsExpandedUserId('');

                                  } else {
                                    setIsExpandedUserId(element.user_id_ids)
                                  }
                                }
                              }}
                            >
                              <td className="d-flex align-items-center">

                                {!element?.invitation_id_ids ? <>
                                  {!impersonateFlag &&
                                    <div className="me-1">
                                      <div className="tooltipCustom">
                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"User impersonate"}</span>
                                        <span
                                          className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                          style={{ height: '35px', width: '35px' }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setImpersonateId(element.user_id_ids);
                                            setImpersonateModal(true)
                                          }}
                                        >
                                          <i className="bi bi-person-fill-gear"></i>
                                        </span>
                                      </div>
                                    </div>
                                  }

                                  {/* {permissionArray.includes("VERIFY USER") && element.is_verified_ysn == 0 && (element.role_id_ids == 1 || element.role_id_ids == 4) &&
                                    <div className="me-1">
                                      <div className="tooltipCustom">
                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Verify for accepting jobs"}</span>
                                        <span
                                          className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                          style={{
                                            height: '35px',
                                            width: '35px',
                                            color: "rgba(45, 204, 99, 1)",
                                            opacity: verifyLoading && isVerifyingUserId == element.user_id_ids ? 0.5 : 1,
                                            pointerEvents: verifyLoading && isVerifyingUserId == element.user_id_ids ? "none" : "auto"
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            verifyUserById(element.user_id_ids, index)
                                            setIsVerifyingUserId(element.user_id_ids, index)
                                          }}
                                        >
                                          {verifyLoading && isVerifyingUserId == element.user_id_ids ?
                                            <Spinner animation="border" size="sm" /> :
                                            <i className="bi bi-check-circle-fill"></i>
                                          }
                                        </span>
                                      </div>
                                    </div>
                                  } */}

                                  {permissionArray.includes("VERIFY USER") && (element.role_id_ids == 1 || element.role_id_ids == 4) &&
                                    <div className="me-1">
                                      <div className="tooltipCustom">
                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{element.is_verified_ysn == 0 ? "Verify for accepting jobs" : "Unverify for accepting jobs"}</span>
                                        <span
                                          className="cursor-pointer  rounded-circle  fs-4 d-flex align-items-center justify-content-center "
                                          style={{
                                            height: '35px',
                                            // width: '35px',
                                            color: "rgba(45, 204, 99, 1)",
                                            opacity: verifyLoading && isVerifyingUserId == element.user_id_ids ? 0.5 : 1,
                                            pointerEvents: verifyLoading && isVerifyingUserId == element.user_id_ids ? "none" : "auto"
                                          }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            // verifyUserById(element.user_id_ids, index, element.is_verified_ysn)
                                            // setIsVerifyingUserId(element.user_id_ids, index)
                                          }}
                                        >
                                          <Form
                                            style={{ zoom: 0.8 }}
                                          >
                                            <Form.Check
                                              type="switch"
                                              id="custom-switch"
                                              className="custom-switch-made "
                                              // label={isChecked ? "Pause jobs" : "Ready for Jobs"}
                                              checked={element.is_verified_ysn}
                                              // onChange={handleToggle}

                                              onChange={(e) => {
                                                e.stopPropagation();
                                                verifyUserById(element.user_id_ids, index, element.is_verified_ysn)
                                                setIsVerifyingUserId(element.user_id_ids, index)
                                              }}
                                              style={{
                                                pointerEvents: verifyLoading && isVerifyingUserId == element.user_id_ids ? "none" : "auto",
                                                opacity: verifyLoading && isVerifyingUserId == element.user_id_ids ? "0.5" : "1",
                                              }}
                                            />
                                          </Form>
                                          {verifyLoading && isVerifyingUserId == element.user_id_ids &&
                                            <span>
                                              <Spinner animation="border" className="mx-2" size="sm" />
                                            </span>
                                          }
                                        </span>
                                      </div>
                                    </div>
                                  }

                                  <div className="me-1">
                                    <div className="tooltipCustom">
                                      <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                      <span
                                        className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                        style={{ height: '35px', width: '35px' }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setDeletingId(element.user_id_ids);
                                          // setShowParticularUserDetails(true);
                                          showUserDetails(e, element);
                                        }}
                                      >
                                        <i className="bi bi-pencil-square"></i>
                                      </span>
                                    </div>
                                  </div>

                                  <div className="tooltipCustom">
                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Delete"}</span>
                                    <span
                                      className={`cursor-pointer rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center ${element?.user_id_ids === isExpandedUserId ? '' : 'text-danger'} `}
                                      style={{ height: '35px', width: '35px' }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setDeletingId(element.user_id_ids);
                                        setBasicModal(true);
                                      }}
                                    >
                                      <i className="bi bi-trash3"></i>
                                    </span>
                                  </div>

                                  {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST") && element.extra_notes_chr) && <div className="tooltipCustom">
                                    <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{`Note added for this user`}</span>
                                    <span
                                      className={`cursor-pointer rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center ${element?.user_id_ids === isExpandedUserId ? '' : 'text-danger'} `}
                                      style={{ height: '35px', width: '35px' }}
                                    >
                                      <i className="bi bi-info-circle"></i>
                                    </span>
                                  </div>}

                                  {permissionArray.includes("VIEW REGISTERED COMPANIES LIST") && (element.role_id_ids == 2) &&
                                    <div className="me-1">
                                      <div className="tooltipCustom">
                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Reset Home Areas"}</span>
                                        <span
                                          className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                          style={{ height: '35px', width: '35px' }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setDeletingId(element.user_id_ids);
                                            setResetHomeAreasModalTrigger(true);
                                          }}
                                        >
                                          <i className="bi bi-house-gear"></i>
                                        </span>
                                      </div>
                                    </div>
                                  }

                                  {permissionArray.includes("VIEW REGISTERED COMPANIES LIST") &&
                                    <div className="me-1">
                                      <div className="tooltipCustom">
                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Send notification"}</span>
                                        <span
                                          className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                          style={{ height: '35px', width: '35px' }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleShowSendNotificationModal(element);
                                          }}
                                        >
                                          <i className="bi bi-send"></i>
                                        </span>
                                      </div>
                                    </div>
                                  }


                                </> :
                                  <>
                                    {element?.invitation_type_int == 2 ?
                                      <>
                                        {element?.status_int == 0 && <div className="me-1">
                                          <div className="tooltipCustom">
                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Accept"}</span>
                                            <span
                                              className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                              style={{
                                                height: '35px',
                                                width: '35px',
                                                color: "rgba(45, 204, 99, 1)",
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleOpenCompanyAdminApproveModal()
                                                setCompanyInvitationObj(element)
                                              }}
                                            >
                                              <i className="bi bi-check-circle-fill"></i>
                                            </span>
                                          </div>
                                        </div>}

                                        {element?.status_int == 2 &&
                                          <div className="me-1" style={{ height: '25px' }}>
                                            <span className="text-danger" >{`Cancelled`}</span>
                                          </div>
                                        }
                                      </>
                                      :
                                      <>
                                        <div className="me-1">
                                          <div className="tooltipCustom">
                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Resend link"}</span>
                                            <span
                                              className="cursor-pointer  rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center "
                                              style={{
                                                height: '35px',
                                                width: '35px',
                                                color: "orange",
                                                opacity: verifyLoading && isVerifyingUserId == element.user_id_ids ? 0.5 : 1,
                                                pointerEvents: verifyLoading && isVerifyingUserId == element.user_id_ids ? "none" : "auto"
                                              }}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleResendCompanyInvitation(element?.invitation_id_ids)
                                                setCompanyInvitationId(element?.invitation_id_ids)
                                              }}

                                            >
                                              {invitationLoading && companyInvitationId == element.invitation_id_ids ?
                                                <Spinner animation="border" size="sm" /> :
                                                <i className="bi bi-send-check"></i>
                                              }
                                            </span>
                                          </div>
                                        </div>


                                      </>
                                    }

                                    {element?.status_int !== 2 && (element?.sent_to_id_lng == localStorage.getItem("user_id")) &&
                                      <div className="tooltipCustom">
                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Cancel invitation"}</span>
                                        <span
                                          className={`cursor-pointer rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center ${element?.user_id_ids === isExpandedUserId ? '' : 'text-danger'} `}
                                          style={{ height: '35px', width: '35px' }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenCancelInvitationModal(element.invitation_id_ids);
                                          }}
                                        >
                                          <i className="bi bi-x-lg"></i>
                                        </span>
                                      </div>
                                    }

                                    {element?.created_by_chr == localStorage.getItem("user_id") &&
                                      <div className="tooltipCustom">
                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Delete invitation"}</span>
                                        <span
                                          className={`cursor-pointer rounded-circle overlay-action-btn fs-4 d-flex align-items-center justify-content-center ${element?.user_id_ids === isExpandedUserId ? '' : 'text-danger'} `}
                                          style={{ height: '35px', width: '35px' }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenDeleteInvitationModal(element.invitation_id_ids);
                                          }}
                                        >
                                          <i className="bi bi-trash3"></i>
                                        </span>
                                      </div>
                                    }

                                    {element?.status_int == 2 && element?.invitation_type_int == 1 &&
                                      <div className="me-1" style={{ height: '25px' }}>
                                        <span className="text-danger" >{`Cancelled`}</span>
                                      </div>
                                    }

                                  </>
                                }
                              </td>

                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    // src={profilePicture}
                                    src={element?.preferred_profile_picture_url}
                                    className={`rounded-lg me-2 ${element?.user_id_ids === isExpandedUserId ? "border" : ""} rounded-3`}
                                    width="24"
                                    height="24"
                                    alt=""
                                    style={{ objectFit: "contain" }}
                                  />{" "}
                                  <span className="w-space-no">{`${element.first_name_chr ? element.first_name_chr : "-"} ${element.last_name_chr ? element.last_name_chr : ""}`}</span>
                                </div>
                              </td>

                              <td>
                                <span
                                  className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                  style={{
                                    background: "rgba(79, 93, 116, 1)",
                                  }}>
                                  {`${element?.role_display_name_chr} `}
                                  {element?.role_id_ids == 1 &&
                                    <span className="fs-7 text-white" style={{ background: "rgba(79, 93, 116, 1)" }}>
                                      {element?.pro_option == 1 ? "(Local Pro)" :
                                        element?.pro_option == 2 ? "(Remote Pro)" :
                                          element?.pro_option == 3 ? "(Estimator Pro)" :
                                            element?.pro_option == 1 ? "(All-in-one)" : ""}
                                    </span>
                                  }
                                </span>
                              </td>


                              <td>
                                <span className="w-space-no">{element.email_chr ? element.email_chr : "-"}</span>
                              </td>

                              <td>
                                <span>{element.phone_number_int == null ? ('-') : <InternationalPhoneFormat countryCode={element.country_phone_code_chr} phoneNumber={`${element.phone_number_int}`} />}</span>
                              </td>

                              <td>
                                {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}

                                <span className="">{`${element?.created_date_dtm ?
                                  new Intl.DateTimeFormat("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: 'numeric',
                                    minute: 'numeric',
                                    hour12: true
                                  }).format(
                                    element?.created_date_dtm * 1000
                                  ) : '-'}`}</span>
                              </td>

                              <td>
                                {/* <span className="">{`${element?.last_log_in_dtm ? formatUnixTimestamp(element?.last_log_in_dtm) : '-'}`}</span> */}

                                <span className="">{`${element?.last_log_in_dtm ?
                                  new Intl.DateTimeFormat("en-US", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: 'numeric',
                                    minute: 'numeric',
                                    hour12: true
                                  }).format(
                                    element?.last_log_in_dtm * 1000
                                  ) : '-'}`}</span>

                              </td>

                              <td>
                                {/* <OverlayTrigger placement="top" overlay={tooltip}> */}
                                {!element?.invitation_id_ids &&
                                  <div
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (element?.user_id_ids === isExpandedUserId) {
                                        setIsExpandedUserId('')
                                      } else {
                                        setIsExpandedUserId(element.user_id_ids)
                                      }
                                    }}
                                    className="d-flex align-items-center justify-content-center bg-light rounded-3 overlay-action-btn text-black"
                                    style={{ fontSize: '15px', height: '30px', width: '35px' }}>
                                    {element?.user_id_ids === isExpandedUserId ? <i class="bi bi-chevron-down"></i> : <i class="bi bi-chevron-right"></i>}
                                  </div>
                                }
                                {/* </OverlayTrigger> */}
                              </td>
                            </tr >

                            <tr>
                              <td colSpan="8" className={`bg-light ${(element?.user_id_ids !== isExpandedUserId) ? 'p-0' : ''}`}>
                                <Collapse
                                  in={element?.user_id_ids === isExpandedUserId}
                                >
                                  <div className='row mx-0'>
                                    <div className='col-12 px-0'>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Full name`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">{`${element.first_name_chr ? element.first_name_chr : "-"} ${element.last_name_chr ? element.last_name_chr : ""}`}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Email`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="" >{element.email_chr ? element.email_chr : "-"}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Phone`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="" >{element.phone_number_int == null ? ('-') : <InternationalPhoneFormat countryCode={element.country_phone_code_chr} phoneNumber={`${element.phone_number_int}`} />}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Created on`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">{`${element?.created_date_dtm ?
                                            new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            }).format(
                                              element?.created_date_dtm * 1000
                                            ) : '-'}`}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`Last login`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          <span className="">{`${element?.last_log_in_dtm ?
                                            new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            }).format(
                                              element?.last_log_in_dtm * 1000
                                            ) : '-'}`}</span>
                                        </div>
                                      </div>

                                      <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 '>
                                          <span className="text-black font-w600">{`User verification status`}</span>
                                        </div>
                                        <div className='col-8 px-0 '>
                                          {/* <span className="">{`${element?.last_log_in_dtm ?
                                            new Intl.DateTimeFormat("en-US", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                              hour: 'numeric',
                                              minute: 'numeric',
                                              hour12: true
                                            }).format(
                                              element?.last_log_in_dtm * 1000
                                            ) : '-'}`}</span> */}

                                          <span className=" font-w600" style={{ color: element?.last_log_in_dtm ? "rgba(45, 204, 99, 1)" : "rgba(255, 0, 0, 1)" }}>{element?.last_log_in_dtm ? `Verified` : `Unverified`}</span>
                                        </div>
                                      </div>

                                      {(element.role_id_ids == 1 || element.role_id_ids == 4) &&
                                        <div className='row mx-0 py-1 fs-6'>
                                          <div className='col-4 px-0 '>
                                            <span className="text-black font-w600">{`Job accepting status`}</span>
                                          </div>
                                          <div className='col-8 px-0 '>
                                            <span className=" font-w600" style={{ color: element?.is_verified_ysn ? "rgba(45, 204, 99, 1)" : "rgba(255, 0, 0, 1)" }}>{element?.is_verified_ysn ? `Verified` : `Unverified`}</span>
                                          </div>
                                        </div>
                                      }

                                      {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST") && element.extra_notes_chr) &&
                                        <div className='row mx-0 py-1 fs-6'>
                                          <div className='col-4 px-0 '>
                                            <span className="text-black font-w600">{`Extra note`}</span>
                                          </div>
                                          <div className='col-8 px-0 '>
                                            <div className="text-wrap">
                                              <span className="">{`${element.extra_notes_chr ? element.extra_notes_chr : "-"}`}</span>
                                            </div>
                                          </div>
                                        </div>
                                      }


                                      {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) && <div className='row mx-0 py-1 fs-6'>
                                        <div className='col-4 px-0 d-flex align-items-center'>
                                          <span className="text-black font-w600">{`Credit balance`}</span>
                                        </div>
                                        <div className='col-8 px-0 d-flex align-items-center'>
                                          <span className="">{`${USDollar.format(element?.total_credits_in_cents_float ? (element?.total_credits_in_cents_float / 100) : 0)}`}</span>

                                          <div
                                            className="d-flex cursor-pointer font-w600 ms-3 overlay-action-btn px-3 py-2 rounded-pill text-white align-items-center"
                                            style={{
                                              border: '1px solid green',
                                              background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                            }}
                                            onClick={() => handleShowAddCreditsModal(element)}
                                          >
                                            {/* <span
                                              className="me-3 rounded-circle d-flex justify-content-center align-items-center bg-white text-black"
                                              style={{ height: '20px', width: '20px', border: '1px solid green' }}
                                            >
                                              <i className="bi bi-plus" />
                                            </span> */}

                                            < i className="bi bi-plus-circle-fill text-white  me-3" style={{ fontSize: '20px', }} />

                                            <span>{`Add credits`}</span>
                                          </div>
                                        </div>
                                      </div>}

                                      {(element.role_id_ids == 1 || element.role_id_ids == 4) &&
                                        <>
                                          <div className='col-12 px-0 d-flex align-items-center'>
                                            <span
                                              className="text-black font-w600 cursor-pointer text-decoration-underline text-hovered"
                                              onClick={() => {
                                                setIsShowMoreDetails(!isShowMoreDetails)
                                                if (!isShowMoreDetails) {
                                                  getWorkInfoFn();
                                                  getProDocumentsFn();
                                                }
                                              }}
                                            >
                                              {isShowMoreDetails ? <span>{`Show less details`}</span> : <span>{`Show more details`}</span>}
                                              {isShowMoreDetails ? <i className="bi bi-chevron-up ms-2" /> : <i className="bi bi-chevron-down ms-2" />}
                                            </span>
                                          </div>

                                          {isShowMoreDetails &&
                                            <div className='col-12'>
                                              <div className="row mx-0 mt-2">
                                                <div className="col-12">
                                                  <span className="text-black font-w600">{`Professional expertise`}</span>
                                                </div>

                                                <div className="col-12 mt-2">

                                                  {proExpertiseLoading ?
                                                    <>
                                                      <div className='mt-2 mx-0 row'>
                                                        {[...Array(3)].map((data, id) => {
                                                          return (
                                                            <div key={id} className=' col-12 col-lg-3 col-md-4 col-sm-12 '>
                                                              <div className='m-1'>
                                                                <div className="row mx-0 shadow bg-white my-2 border" style={{ height: "", borderRadius: '4px' }}>
                                                                  <div className="col-12 d-flex p-2">

                                                                    <div>
                                                                      <SkeletonDivElement height={'80px'} width={'90px'} borderRadius={'4px'} />
                                                                    </div>

                                                                    <div className="w-100 h-100 d-flex flex-column justify-content-between ms-3">
                                                                      <div>
                                                                        <div className="mb-2">
                                                                          <SkeletonDivElement height={'20px'} width={'30%'} borderRadius={'14px'} />
                                                                        </div>

                                                                        <div className="mb-2">
                                                                          <SkeletonDivElement height={'20px'} width={'50%'} borderRadius={'14px'} />
                                                                        </div>

                                                                        <div className="mb-2">
                                                                          <SkeletonDivElement height={'20px'} width={'50%'} borderRadius={'14px'} />
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          )
                                                        }
                                                        )}
                                                      </div>
                                                    </> :
                                                    <>
                                                      {proExpertiseArr?.length > 0 ?
                                                        <div className='row h-100 mx-0 '>
                                                          <div className='col-12 px-0' style={{}}>
                                                            <div className='mt-2 mx-0 row'>
                                                              {proExpertiseArr?.map((element, index) => {
                                                                return (
                                                                  <div key={index} className=' col-12 col-lg-3 col-md-4 col-sm-4 '>
                                                                    <div className='bg-white border rounded-3 p-3 shadow-sm m-1'>
                                                                      <div className='row mx-0'>
                                                                        <div className='col-12 px-0 d-flex'>

                                                                          <div
                                                                            className='align-items-center d-flex justify-content-center rounded-3 border text-black me-3'
                                                                            style={{ width: '70px' }}
                                                                          >
                                                                            {element?.category_image_url_chr ?
                                                                              <img src={element?.category_image_url_chr} className='w-100 h-100' style={{ objectFit: 'contain' }} alt='' />
                                                                              :
                                                                              <i class="align-self-center bi bi-gear-wide-connected"></i>
                                                                            }
                                                                          </div>

                                                                          <div className='d-flex justify-content-between w-100'>
                                                                            <div className=' px-0 text-black'>
                                                                              <div className='fs-6 fw-bold row mb-1'>
                                                                                <span>{`${element?.expertise_display_name_chr == "Home Check-Up" ? "Home Inspector" : element?.expertise_display_name_chr}`}</span>
                                                                              </div>
                                                                              <div className='row fs-7'>
                                                                                <span>{`${element?.work_experience_int} years experience`}</span>
                                                                              </div>
                                                                              <div className='font-w600 row fs-7 d-flex'>
                                                                                <div className='col-12'>
                                                                                  <span>{`${element?.expertise_competency_name}, `}</span>
                                                                                  <span>{`${element?.is_certified_ysn == 1 ? "Certified" : "Not certified"}`}</span>
                                                                                  {element?.is_certified_ysn == 1 && <span><i className="bi bi-patch-check-fill ps-2 text-success"></i></span>}
                                                                                </div>

                                                                              </div>
                                                                            </div>

                                                                            {/* <div className='px-0 text-black'>
                                                                        <div className='fs-5 fw-bold row mb-1'>

                                                                          <div className="tooltipCustom">
                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"More"}</span>
                                                                            <OverlayTrigger
                                                                              key={index}
                                                                              trigger="click"
                                                                              placement="bottom"
                                                                              // overlay={popover}
                                                                              overlay={popover(index)}
                                                                              rootClose={true}
                                                                              show={activePopover === index}
                                                                              onToggle={(show) => setActivePopover(show ? index : null)}
                                                                            >
                                                                              <span
                                                                                className='d-flex align-items-center justify-content-center more-option rounded-circle'
                                                                                style={{ height: '30px', width: '30px' }}
                                                                                onClick={() => handleMenuClick(element, index)}
                                                                              >
                                                                                <i class="bi bi-three-dots-vertical cursor-pointer"></i>
                                                                              </span>
                                                                            </OverlayTrigger>
                                                                          </div>
                                                                        </div>
                                                                      </div> */}
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                )
                                                              })
                                                              }

                                                            </div>

                                                          </div>
                                                        </div> :
                                                        <div className='row align-items-center h-100 mx-0 '>
                                                          <div className='col-12 px-0' style={{}}>


                                                            <div className='d-flex align-items-center mx-0 row'>
                                                              <div className='col-12 px-0'>
                                                                <span>
                                                                  No expertise added yet
                                                                </span>
                                                              </div>
                                                            </div>

                                                          </div>
                                                        </div>
                                                      }
                                                    </>}



                                                </div>
                                              </div>

                                              <div className="row mx-0 mt-2">
                                                <div className="col-12">
                                                  <span className="text-black font-w600">{`Professional documents`}</span>
                                                </div>

                                                <div className="col-12 mt-2">

                                                  {proDocumentsLoading ?
                                                    <>
                                                      <div className='mt-2 mx-0 row'>
                                                        {[...Array(3)].map((data, id) => {
                                                          return (
                                                            <div key={id} className=' col-12 col-lg-3 col-md-4 col-sm-12 '>
                                                              <div className='m-1'>
                                                                <div className="row mx-0 shadow bg-white my-2 border" style={{ height: "", borderRadius: '4px' }}>
                                                                  <div className="col-12 d-flex p-2">

                                                                    <div>
                                                                      <SkeletonDivElement height={'80px'} width={'90px'} borderRadius={'4px'} />
                                                                    </div>

                                                                    <div className="w-100 h-100 d-flex flex-column justify-content-between ms-3">
                                                                      <div>
                                                                        <div className="mb-2">
                                                                          <SkeletonDivElement height={'20px'} width={'30%'} borderRadius={'14px'} />
                                                                        </div>

                                                                        <div className="mb-2">
                                                                          <SkeletonDivElement height={'20px'} width={'50%'} borderRadius={'14px'} />
                                                                        </div>

                                                                        <div className="mb-2">
                                                                          <SkeletonDivElement height={'20px'} width={'50%'} borderRadius={'14px'} />
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          )
                                                        }
                                                        )}
                                                      </div>
                                                    </> :
                                                    <>
                                                      {proDocumentsArr?.length > 0 ?

                                                        <div className='row h-100 mx-0 '>
                                                          <div className='col-12 px-0' style={{}}>
                                                            <div className='mt-2 mx-0 row'>
                                                              {proDocumentsArr?.map((item, index) => {
                                                                return (
                                                                  <div key={index} className=' col-12 col-lg-3 col-md-4 col-sm-4 '>
                                                                    <div
                                                                      className='bg-white border rounded-3 p-3 shadow-sm m-1'
                                                                    >
                                                                      <div className='row mx-0'>
                                                                        <div className='col-12 px-0 d-flex'>
                                                                          <div
                                                                            className='align-items-center d-flex justify-content-center rounded-3 border text-black me-3 overflow-hidden'
                                                                            style={{ width: '70px', height: '50px' }}
                                                                          >
                                                                            {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                                                                            <img
                                                                              onClick={() => {
                                                                                handleOpenDoc(); setImageAttachURL(item?.document_url_chr);
                                                                              }}
                                                                              className='documents-individual-box-img rounded-3 w-100 h-100'
                                                                              src={item?.document_url_chr}
                                                                              alt=''
                                                                              style={{ objectFit: 'contain' }}
                                                                            />
                                                                          </div>

                                                                          <div className='d-flex justify-content-between w-100'>
                                                                            <div className='px-0 text-black'>
                                                                              <div className='fs-6 fw-bold row mb-1'>
                                                                                <span>
                                                                                  {item?.document_type_int == 1 ? "Identity" :
                                                                                    item?.document_type_int == 2 ? "Certification" :
                                                                                      item?.document_type_int == 3 ? "Address" :
                                                                                        item?.document_type_int == 4 ? "Insurance" : "Other"}
                                                                                </span>
                                                                              </div>

                                                                              <div className='row fs-7'>
                                                                                <span>{item?.note_chr}</span>
                                                                              </div>

                                                                              {/* <div className='row fs-7'>
                                                                                                                           {(item?.country_name_chr || item?.state_name_chr) && <span>{`${item?.country_name_chr && item?.country_name_chr}, ${item?.state_name_chr && item?.state_name_chr}`}</span>}
                                                                                                                       </div> */}

                                                                              {/* <div className='font-w500 row fs-7 '>
                                                                                                                           <div>
                                                                                                                               <i className="bi bi-patch-check-fill pe-2 text-success"></i>
                                                                                                                               <span >
                                                                                                                                   {item?.note_chr}
                                                                                                                               </span>
                                                                                                                           </div>
                                                                                                                       </div> */}
                                                                            </div>

                                                                            {/* <div className=' px-0 text-black'>
                                                                          <div className='fs-5 fw-bold row mb-1'>
                                                                            <div className="tooltipCustom">
                                                                              <span className="tooltiptextCustom w-100" style={{ minWidth: "max-content" }}>{"More"}</span>
                                                                              <OverlayTrigger
                                                                                key={index}
                                                                                trigger="click"
                                                                                placement="bottom"
                                                                                overlay={popoverDocument(index)}
                                                                                rootClose={true}
                                                                                show={activePopover === index}
                                                                                onToggle={(show) => setActivePopover(show ? index : null)}
                                                                              >
                                                                                <span
                                                                                  className='d-flex align-items-center justify-content-center more-option rounded-circle'
                                                                                  style={{ height: '30px', width: '30px' }}
                                                                                  onClick={() => handleMenuClick(item, index)}
                                                                                >
                                                                                  <i class="bi bi-three-dots-vertical cursor-pointer"></i>
                                                                                </span>
                                                                              </OverlayTrigger>
                                                                            </div>
                                                                          </div>
                                                                        </div> */}
                                                                          </div>
                                                                        </div>


                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                )
                                                              })
                                                              }

                                                            </div>

                                                          </div>
                                                        </div> :
                                                        <div className='row align-items-center h-100 mx-0 '>
                                                          <div className='col-12 px-0' style={{}}>


                                                            <div className='d-flex align-items-center mx-0 row'>
                                                              <div className='col-12 px-0'>
                                                                <span>
                                                                  No documents added yet
                                                                </span>
                                                              </div>
                                                            </div>

                                                          </div>
                                                        </div>
                                                      }
                                                    </>
                                                  }

                                                </div>
                                              </div>
                                            </div>

                                          }

                                        </>
                                      }

                                    </div>
                                  </div>
                                </Collapse>
                              </td>
                            </tr>
                          </>
                        )
                      })}</> :
                    <tr>
                      <td colSpan="8">No Records Found</td>
                    </tr>
                  }
                </>
              }
            </tbody>
          </Table>

        </div>
      </div >

      {/* Modal for accept pro in company by Company Admin */}
      < Modal className='fade' centered show={companyAdminApproveModal} >
        <Modal.Body>
          <div className='row mx-0'>
            <div className='col-12 px-0'>
              <>
                <div className='mx-0 row text-black mb-4'>
                  <div className='col-11 font-w600 fs-3 px-0 text-center'>
                    <span>
                      {"Approve request"}
                    </span>
                  </div>
                  <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                    <span onClick={() => handleCloseCompanyAdminApproveModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>


                <>
                  <div className='fs-4 font-w600 text-black text-center mb-5'>
                    <span>
                      {`${companyInvitationObj.sender_first_name ? companyInvitationObj.sender_first_name : "User"} has requested to join ${companyInvitationObj.company_name_chr} as ${companyInvitationObj?.role_display_name_chr}`}
                    </span>
                  </div>


                  <div className='row mt-5 w-100 '>

                    <div className='col-6 pe-2 mt-2'>
                      <PrimaryButton
                        buttonName={`CANCEL`}
                        onClick={(e) => { handleCloseCompanyAdminApproveModal() }}
                        loadingMessage={"Saving..."}
                        isLoading={false}
                        style={{
                          width: '100%',
                          background: '#4e5d74',
                          border: 'none',
                          boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                          fontWeight: '600',
                        }}
                      />
                    </div>

                    <div className='col-6 ps-2 mt-2'>
                      <PrimaryButton
                        buttonName={`APPROVE`}
                        onClick={(e) => { handleCompanyAdminApproveRequest() }}
                        loadingMessage={"ACCEPTING..."}
                        isLoading={invitationLoading}
                        style={{
                          width: '100%',
                          border: 'none',
                          background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                          boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                          fontWeight: '600',
                        }}
                      />
                    </div>
                  </div>
                </>
              </>
            </div>
          </div>
        </Modal.Body>
      </Modal >

      {/* Add credits by super admin */}
      <Modal className='fade' centered show={addCreditsModalTrigger}>
        <Modal.Body>
          <div className='row mx-0'>
            <div className='col-12 px-0'>
              <>
                <div className='row mx-0'>

                  <div className='col-12 px-0 d-flex justify-content-end'>
                    <span onClick={() => { handleCloseAddCreditsModal() }} className='cursor-pointer fs-4 text-black text-hovered'>
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>
                <div className='mx-0 row text-black mb-4'>
                  <div className='col-12 font-w600 fs-3 px-0 text-center'>
                    <span>
                      {`Add credits`}
                    </span>
                  </div>
                </div>

                <div className='mx-0 row mb-3'>
                  <div className='col-12 font-w500 fs-5 px-0 text-center font-w600'>
                    <span>
                      {"Provide additional credits to the user's account to enhance their experience."}
                    </span>
                  </div>
                </div>

                <div className='row mx-0 mb-3'>
                  <div className='col-12 px-0'>

                    <div className='row mx-0 py-1 fs-6'>
                      <div className='col-6 px-0 '>
                        <span className="text-black font-w600">{`Full name`}</span>
                      </div>
                      <div className='col-6 px-0 '>
                        <span className="">{`${particularUserDetails.first_name_chr ? particularUserDetails.first_name_chr : "-"} ${particularUserDetails.last_name_chr ? particularUserDetails.last_name_chr : ""}`}</span>
                      </div>
                    </div>

                    <div className='row mx-0 py-1 fs-6'>
                      <div className='col-6 px-0 '>
                        <span className="text-black font-w600">{`Email`}</span>
                      </div>
                      <div className='col-6 px-0 '>
                        <span className="" >{particularUserDetails.email_chr ? particularUserDetails.email_chr : "-"}</span>
                      </div>
                    </div>

                    <div className='row mx-0 py-1 fs-6'>
                      <div className='col-6 px-0 '>
                        <span className="text-black font-w600">{`Phone`}</span>
                      </div>
                      <div className='col-6 px-0 '>
                        <span className="" >{particularUserDetails.phone_number_int == null ? ('-') : <InternationalPhoneFormat countryCode={particularUserDetails.country_phone_code_chr} phoneNumber={`${particularUserDetails.phone_number_int}`} />}</span>
                      </div>
                    </div>

                    <div className='row mx-0 py-1 fs-6'>
                      <div className='col-6 px-0 '>
                        <span className="text-black font-w600">{`Created on`}</span>
                      </div>
                      <div className='col-6 px-0 '>
                        <span className="">{`${particularUserDetails?.created_date_dtm ?
                          new Intl.DateTimeFormat("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: true
                          }).format(
                            particularUserDetails?.created_date_dtm * 1000
                          ) : '-'}`}</span>
                      </div>
                    </div>

                    <div className='row mx-0 py-1 fs-6'>
                      <div className='col-6 px-0 '>
                        <span className="text-black font-w600">{`Last login`}</span>
                      </div>
                      <div className='col-6 px-0 '>
                        <span className="">{`${particularUserDetails?.last_log_in_dtm ?
                          new Intl.DateTimeFormat("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: true
                          }).format(
                            particularUserDetails?.last_log_in_dtm * 1000
                          ) : '-'}`}</span>
                      </div>
                    </div>

                    {(particularUserDetails.role_id_ids == 1 || particularUserDetails.role_id_ids == 4) &&
                      <div className='row mx-0 py-1 fs-6'>
                        <div className='col-6 px-0 '>
                          <span className="text-black font-w600">{`Job accepting status`}</span>
                        </div>
                        <div className='col-6 px-0 '>
                          <span className=" font-w600" style={{ color: particularUserDetails?.is_verified_ysn ? "rgba(45, 204, 99, 1)" : "rgba(255, 0, 0, 1)" }}>{particularUserDetails?.is_verified_ysn ? `Verified` : `Unverified`}</span>
                        </div>
                      </div>
                    }

                    {(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")) && <div className='row mx-0 py-1 fs-6'>
                      <div className='col-6 px-0 '>
                        <span className="text-black font-w600">{`Available credit balance`}</span>
                      </div>
                      <div className='col-6 px-0 d-flex align-items-center'>
                        <span className="">{`${USDollar.format(particularUserDetails?.total_credits_in_cents_float ? (particularUserDetails?.total_credits_in_cents_float / 100) : 0)}`}</span>

                      </div>
                    </div>}

                  </div>
                </div>

                <form onSubmit={(e) => { handleAddCredits(e); }}>
                  <div>
                    <div className='row mx-0 mt-3'>
                      <div className='col-12 px-0'>
                        <InputField
                          labelName={"Enter amount to credit"}
                          placeholderName={"Enter amount to credit"}
                          value={numberOfCredits}
                          onChange={handleNumberOfCredits}
                          onBlur={() => { handleNumberOfCreditsBlurCheck() }}
                          errorOccured={isNumberOfCreditsErr}
                          errorMeesage={`Please enter valid amount`}
                          autoF={true}
                        />
                      </div>
                    </div>

                    <div className='row mx-0 mt-3'>
                      <div className='col-12 px-0'>
                        <PrimaryButton
                          onClick={(e) => {
                            handleAddCredits(e);
                          }}
                          buttonName={"SUBMIT"}
                          type="submit"
                          loadingMessage="SAVING..."
                          isLoading={addCreditsLoading}
                          style={{
                            width: '100%',
                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                            border: 'none',
                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </>
            </div>
          </div>
        </Modal.Body>
      </Modal >

      {/* Send notification to particular user by super admin */}
      <Modal className='fade' centered show={sendNotificationModalTrigger}>
        <Modal.Body>
          <div className='row mx-0'>
            <div className='col-12 px-0'>
              <>
                <div className='row mx-0'>

                  <div className='col-12 px-0 d-flex justify-content-end'>
                    <span
                      onClick={() => {
                        handleClearSendNotification();
                      }}
                      className='cursor-pointer fs-4 text-black text-hovered'
                    >
                      <i className="bi bi-x-lg"></i>
                    </span>
                  </div>
                </div>

                {/* <div className='mx-0 row text-black mb-4'>
                  <div className='col-12 font-w600 fs-3 px-0 text-center'>
                    <span>
                      {`Send notification to ${particularUserDetails.first_name_chr ? particularUserDetails.first_name_chr : ""} ${particularUserDetails.last_name_chr ? particularUserDetails.last_name_chr : ""}`}
                    </span>
                  </div>
                </div> */}

                <div className='w-100'>

                  <div className='d-flex justify-content-center mb-4'>
                    <span className='text-black font-w600 fs-3 text-center'>{`Send notification to ${particularUserDetails.first_name_chr ? particularUserDetails.first_name_chr : ""} ${particularUserDetails.last_name_chr ? particularUserDetails.last_name_chr : ""}`}</span>
                  </div>

                  {/* Navigations Bar */}
                  <div
                    className='border-bottom mb-4 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'
                  >
                    <div className='col-12 d-flex px-0 fs-5 font-w500'>
                      <div
                        onClick={() => {
                          setSendNotificationsNav(1);
                        }}
                        className={`cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative`}
                        style={{}}
                      >
                        <span className={`${sendNotificationsNav === 1 ? "text-black" : "text-grey"} ${sendNotificationsNav === 1 && "fw-bold"}`} >{"Push Notifications"}</span>
                        {sendNotificationsNav === 1 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}
                      </div>

                      {particularUserDetails?.email_chr &&
                        <div
                          onClick={() => {
                            setSendNotificationsNav(2)
                          }}
                          className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                          style={{}}
                        >
                          <span className={`${sendNotificationsNav === 2 ? "text-black" : "text-grey"} ${sendNotificationsNav === 2 && "fw-bold"}`}>{"Email"}</span>
                          {sendNotificationsNav === 2 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                        </div>
                      }

                      {particularUserDetails?.phone_number_int &&
                        <div
                          onClick={() => {
                            setSendNotificationsNav(3)
                          }}
                          className='cursor-pointer overlay-action-btn align-items-cente d-flex justify-content-center px-4 py-3 position-relative'
                          style={{}}
                        >
                          <span className={`${sendNotificationsNav === 3 ? "text-black" : "text-grey"} ${sendNotificationsNav === 3 && "fw-bold"}`}>{`SMS`}</span>
                          {sendNotificationsNav === 3 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                        </div>
                      }
                    </div>
                  </div>

                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (sendNotificationsNav === 1) {
                        handleSendNotification()
                      } else if (sendNotificationsNav === 2) {
                        handleSendEmailNotification()
                      } else if (sendNotificationsNav === 3) {
                        handleSendTextMessageNotification()
                      }
                    }}
                  >
                    {sendNotificationsNav !== 3 &&
                      <div className='row mx-0 mb-4'>



                        <div className='col-12 p-1 d-flex justify-content-between align-items-center border rounded-2 '>
                          <div className='ps-3'>
                            <span className='fs-6 font-w600 '>{`Add ${sendNotificationsNav === 1 ? 'picture to your notification' : 'attachment to email'}`}</span>
                          </div>


                          <div className='d-flex overflow-auto'>
                            {attachedImage0 == null &&
                              <div
                                className='rounded-2 d-flex flex-column justify-content-center align-items-center cursor-pointer overlay-action-btn'
                                style={{
                                  border: '2px solid orange',
                                  height: '65px',
                                  width: '100px',
                                  backgroundColor: "rgb(215 225 243)",
                                  opacity: uploadImgLoading ? '0.5' : '1',
                                  pointerEvents: uploadImgLoading ? 'none' : 'auto',
                                }}
                                onClick={handleClickAttachedImage0}
                              >
                                {uploadImgLoading ?
                                  <>
                                    <Spinner animation="border" size="sm" variant="primary" />
                                  </> :
                                  <>
                                    <span>
                                      <i className="bi bi-plus-lg fs-4"></i>
                                    </span>
                                    <span className='font-w600 fs-7'>
                                      {`Add ${sendNotificationsNav === 1 ? 'photo' : 'attachment'}`}
                                    </span>
                                  </>}
                                <input ref={attachedImage0Ref} type="file" accept={`image/*, ${sendNotificationsNav === 2 ? 'application/pdf' : ''} `} hidden onChange={(e) => { handleAttachedImage0(e) }} />
                              </div>
                            }

                            {attachedImage0 !== null &&
                              <div
                                className='rounded-2 overflow-hidden position-relative d-flex flex-column justify-content-center align-items-center cursor-pointer overlay-action-btn shadow me-1'
                                style={{ border: '2px solid orange', height: '65px', width: '100px', backgroundColor: "rgb(215 225 243)", }}
                                onClick={() => {
                                  handleOpenDoc();
                                  setImageAttachURL(attachedImage0);
                                }}
                              >
                                <span
                                  className='position-absolute cursor-pointer rounded-circle text-danger d-flex justify-content-center align-items-center'
                                  style={{ top: '3px', right: '3px', border: '1px solid red', width: '25px', height: '25px', zIndex: '2' }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e?.stopPropagation();
                                    deleteAttachedImage0()
                                  }}
                                >
                                  <i className="bi bi-x-lg"></i>
                                </span>
                                <img src={attachedImage0} className='rounded-2 documents-individual-box-img' alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                              </div>}
                          </div>


                        </div>

                      </div>
                    }

                    {Object.keys(particularUserRolesArr).length > 1 &&
                      <div className='mx-0 row'>
                        <div className='col-12 px-0'>
                          {isMounted && <SelectPeriodFilter
                            labelName={`Send to`}
                            onChange={(e) => handleParticularUserRoleFilter(e)}
                            defaultValue={particularUserRole}
                            options={particularUserRolesArr}
                            errorOccured={false}
                            errorMessage={""}
                          />}
                        </div>
                      </div>
                    }

                    {sendNotificationsNav !== 3 &&
                      <div className='mx-0 row mb-2'>
                        <div className='col-12 px-0'>
                          <InputField
                            labelName={"Title"}
                            placeholder={"Notification title"}
                            value={notificationTitle}
                            onChange={handleChangeNotificationTitle}
                            onBlur={handleChangeNotificationTitleBlurCheck}
                            errorOccured={notificationTitleErr}
                            errorMeesage={"Please enter notification title"}
                            isRequired={true}
                          />
                        </div>
                      </div>
                    }

                    <div className='mx-0 row mb-2'>
                      <div className='col-12 px-0'>
                        {(sendNotificationsNav == 1 || sendNotificationsNav == 3) && <TextArea
                          labelName={`Description (text or talk) *`}
                          placeholder={`Provide us detail to your project and we can automatically provide you a step by step plan.`}
                          value={notificationDescription}
                          onChange={handleChangeNotificationDescription}
                          onBlur={handleChangeNotificationDescriptionBlurCheck}
                          errorOccured={notificationDescriptionErr}
                          errorMessage={"Enter notification description"}
                          // autoActivated={true}
                          // isPlaceholder={true}
                          rows={'7'}
                        />}

                        {(sendNotificationsNav == 2) &&
                          <TextEditor content={notificationDescription} setContent={setNotificationDescription} />
                        }
                      </div>
                    </div>




                    <div className='row mx-0'>
                      <div
                        className='col-12 px-0'
                        style={{
                          // pointerEvents: sendNotificationsNav === 3 ? "none" : "auto",
                          // opacity: sendNotificationsNav === 3 ? "0.5" : "1",
                        }}
                      >
                        <PrimaryButton
                          buttonName={`SEND`}
                          onClick={(e) => {
                            e.preventDefault();
                            if (sendNotificationsNav === 1) {
                              handleSendNotification()
                            } else if (sendNotificationsNav === 2) {
                              handleSendEmailNotification()
                            } else if (sendNotificationsNav === 3) {
                              handleSendTextMessageNotification()
                            }
                          }}
                          isLoading={sendNotificationLoading}
                          loadingMessage={"SENDING..."}
                          style={{
                            width: '100%',
                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                            border: '2px solid rgba(255, 154, 32, 1)',
                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                            fontWeight: '600',
                          }}
                        />
                      </div>
                    </div>
                  </form>
                </div>


              </>
            </div>
          </div>
        </Modal.Body>
      </Modal >

      {/* Modal for previewing the attached image preview */}
      <>
        <Modal show={openDoc} onHide={handleCloseDoc} centered style={{ background: '#fff0', border: 'none', }}>

          <div className='image-preview-modal-header'>

            <a href={imageAttachURL} target="_blank" rel="noreferrer">
              <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
            </a>

            <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
              <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
            </div>

          </div>

          <>
            <img src={imageAttachURL} alt='document' style={{ width: '100%', height: '100%' }} />
          </>

        </Modal>
      </>


      <AcceptRejectModal
        text={txtDeleteAccountConfirmation}
        modalStatus={basicModal}
        onClickAccept={deleteAccount}
        onClickReject={() => setBasicModal(false)}
        loaderActive={deleteUserLoading}
        loadingButtonName={"Deleting..."}
      />

      {
        impersonateModal && <AcceptRejectModal
          text={"Are you sure you want to impersonate this user?"}
          modalStatus={impersonateModal}
          onClickAccept={impersonateUserById}
          onClickReject={() => setImpersonateModal(false)}
        />
      }

      {
        deleteInvitationModalTrigger && <AcceptRejectModal
          text={"Are you sure you want to delete this invitation?"}
          modalStatus={deleteInvitationModalTrigger}
          onClickAccept={handleDeleteCompanyInvitationFn}
          onClickReject={() => handleCloseDeleteInvitationModal()}
          loaderActive={invitationLoading}
          loadingButtonName={"DELETING..."}
        />
      }

      {
        cancelInvitationModalTrigger && <AcceptRejectModal
          text={"Are you sure you want to cancel this invitation?"}
          modalStatus={cancelInvitationModalTrigger}
          onClickAccept={handleCancelCompanyInvitationFn}
          onClickReject={() => handleCloseCancelInvitationModal()}
          loaderActive={invitationLoading}
          loadingButtonName={"CANCELING..."}
        />
      }

      {
        showAddUser && <AddUserByAdmin
          addUserTrigger={showAddUser}
          handleCloseAddUser={handleCloseAddUser}
        />
      }
      {
        showParticularUserDetails && <ParticularUserDetailsForAdmin
          particularUserDetailsTrigger={showParticularUserDetails}
          handleCloseParticularUserDetails={handleCloseParticularUserDetails}
          id={deletingId}
        />
      }

      {resetHomeAreasModalTrigger &&
        <AcceptRejectModal
          text={`Are you sure you want to reset this users home areas?`}
          modalStatus={resetHomeAreasModalTrigger}
          onClickAccept={handleResetHomeSetup}
          onClickReject={() => setResetHomeAreasModalTrigger(false)}
          loaderActive={resetHomeAreasLoading}
          loadingButtonName={"RESETTING..."}
        />
      }

      {
        handleToaster && (
          <ResponceToaster toasterType={toasterType} message={resMessage} />
        )
      }





    </>
  );
};

export default AdminDashboard;
